import React, { useState, useEffect } from 'react';
import Spinner from './spinner.js';
import start from '../assets/start.png';
import PixelatedInput from './pixelated_input.js';
import OvalButton from './oval_button.js';
import { getKRandomNumbersUpToN, getAnswerChoice, generatePastelColors } from '../util.js';
import { QuizQuestion } from '../types.js';

const VALID_STATUSES = ['watching', 'completed', 'on_hold', 'dropped', 'plan_to_watch'];

const QuizConfirmation = ({
    animes,
    statusToAnimeSongs,
    quizType,
    setBgColor,
    setQuizType,
    setQuizQuestions,
    goToNextPage}) => {

    const [statuses, setStatuses] = useState([]);
    const [quizLength, setQuizLength] = useState(1);
    const [bgColors, ] = useState(generatePastelColors(2));

    useEffect(() => {
        setBgColor(bgColors[0]);
    });

    const handleQuizLengthChange = (e) => {
        setQuizLength(parseInt(e.target.value));
    };

    const handleStatusChange = (e) => {
        const { value, checked } = e.target;
        setStatuses((prevStatuses) =>
            (checked ? [...prevStatuses, value] : prevStatuses.filter((status) => status !== value))
        );
    };

    const getTotalSongsInStatuses = () => {
        let total = 0;
        for (let status of statuses) {
            total += (statusToAnimeSongs.get(status) ?? []).length;
        }
        return total;
    }


    async function createQuizQuestionFromAnimeSong(song, eligibleSongs) {
        let link = await getYoutubeLink(song);
        if (!link) {
            console.log("Couldn't find link for " + song.cleanedName);
            return [];
        }
        let answerChoices = [];
        if (quizType === 'multiple choice') {
            let correctChoiceIncluded = false;
            answerChoices = getKRandomNumbersUpToN(6, eligibleSongs.length)
                .map(i => {
                    let randomSong = eligibleSongs[i];
                    if (randomSong === song) {
                        correctChoiceIncluded = true;
                    }
                    return getAnswerChoice(randomSong);
                });
            if (!correctChoiceIncluded) {
                let correctChoiceIndex = getKRandomNumbersUpToN(1, 6);
                answerChoices[correctChoiceIndex] = getAnswerChoice(song);
            }
        }
        return new QuizQuestion(song, link, answerChoices);
    }

    async function getYoutubeLink(song) {
        let query = song.cleanedName;
        let searchRes = await fetch(`/searchVideos/${encodeURIComponent(query)}`);
        return await searchRes.text();
    }

    async function generateQuizQuestions() {
        let songs = [];
        console.log("generating quiz questions with statuses" + statuses);
        for (let status of statuses) {
            songs.push(...statusToAnimeSongs.get(status) ?? []);
        }
        let randomSongIndices = getKRandomNumbersUpToN(quizLength, songs.length);
        let randomSongs = randomSongIndices.map(i => songs[i]);
        let quizQuestionPromises = randomSongs.map(randomSong => {
            return createQuizQuestionFromAnimeSong(randomSong, songs);
        });
        let quizQuestions = (await Promise.all(quizQuestionPromises)).flat();
        console.log("Quiz questions: ");
        console.log(quizQuestions);
        setQuizQuestions(quizQuestions);
    }

    if (animes.length === 0) {
        return <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
        }}>
            <Spinner />
        </div>
    }

    return (
        <div>
            <h2>Found {animes.length} animes on your MAL! </h2>
            <div>
                <h3>Which anime statuses do you want to include?</h3>
                {VALID_STATUSES.map((status) => (
                    <div key={status}>
                        <label>
                            <input
                                type="checkbox"
                                value={status}
                                checked={statuses.includes(status)}
                                onChange={handleStatusChange} />
                            {status.toUpperCase()} ({(statusToAnimeSongs.get(status) ?? []).length} songs found)
                        </label>
                    </div>
                ))}
            </div>
            <h3>Desired quiz length? (max: {getTotalSongsInStatuses()})</h3>
            <PixelatedInput
                numberFieldInfo={{
                    min: 1,
                    max: getTotalSongsInStatuses(),
                    default: 1,
                }}
                onChange={handleQuizLengthChange}
                placeholder={1}
                />
            <h3>Free-form or multiple choice?</h3>
            <div>
                <input
                    type='radio'
                    name='options'
                    value='free-form'
                    checked={quizType === 'free-form'}
                    onChange={() => setQuizType('free-form')}
                    />
                <label>FREE FORM</label>
            </div>
            <div>
                <input
                    type='radio'
                    name='options'
                    value='mulitple choice'
                    checked={quizType === 'multiple choice'}
                    onChange={() => setQuizType('multiple choice')}
                    />
                <label>MULTIPLE CHOICE</label>
            </div>
            <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: '20px',
                }}>
                <OvalButton
                    bgColor={bgColors[1]}
                    imageContent={start}
                    onMouseDown={() => {}}
                    onMouseUp={() => setTimeout(() => {
                        generateQuizQuestions();
                        goToNextPage()
                    }, 400)}/>
            </div>
        </div>
      );
};

export default QuizConfirmation;